import { useCallback, useMemo, useState } from 'react';
import {
  useBondScreenerViewsContext,
} from '@/creditflowresearch/application/BondScreener/Sidebar/BondScreenerViewsContext';
import { BondScreenerSelectViewButton } from '@/creditflowresearch/ui/common/components/molecules/BondScreenerSelectViewButton';
import {
  BondScreenerCreateViewModal,
} from '@/creditflowresearch/ui/common/components/molecules/BondScreenerCreateViewModal';
import LoginOrSignUpPopover from '@/creditflowresearch/ui/common/components/LoginOrSignUpPopover';
import { DEFAULT_VIEW_OPTION, buildViewOptions } from './CustomizationPanel/bondScreenerViewOptions';

interface IBondScreenerHeaderViewSelectProps {
  dataTest: string,
  isRestricted?: boolean,
}

export const BondScreenerHeaderViewSelect = ({
  dataTest,
  isRestricted = false,
}: IBondScreenerHeaderViewSelectProps) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { views, activeViewId, selectAndApplyView, saveAsNewView, canCreateView } = useBondScreenerViewsContext();

  const viewOptions = useMemo(() => buildViewOptions(views), [views]);

  const handleSelectView = useCallback((id: string | null): void => {
    selectAndApplyView(id === DEFAULT_VIEW_OPTION.value ? null : id);
  }, [selectAndApplyView]);

  const toggleCreateModal = useCallback((isVisible: boolean): void => setIsCreateModalOpen(isVisible), []);

  const handleCreateView = useCallback((name: string): void => {
    toggleCreateModal(false);
    saveAsNewView(name);
  }, [toggleCreateModal, saveAsNewView]);

  return (
    <>
      <LoginOrSignUpPopover isRestricted={ isRestricted } placement="bottom">
        <BondScreenerSelectViewButton
          dataTest={ dataTest }
          views={ viewOptions }
          activeViewId={ activeViewId ?? DEFAULT_VIEW_OPTION.value }
          onSelectView={ handleSelectView }
          onCreateView={ () => toggleCreateModal(true) }
          canCreateView={ canCreateView }
          disabled={ isRestricted }
        />
      </LoginOrSignUpPopover>
      <BondScreenerCreateViewModal
        isVisible={ isCreateModalOpen }
        existingNames={ views.map((view) => view.name) }
        onCreate={ handleCreateView }
        onCancel={ () => toggleCreateModal(false) }
      />
    </>
  );
};
